import type { FC } from 'react';

import { ErrorMessageForm } from 'components/forms/error-message-form/ErrorMessageForm';

type Props = {
  name?: string;
};

export const JoinLinkExpired: FC<Props> = ({ name }) => (
  <ErrorMessageForm
    titleCaption="This link has expired"
    titleContent={
      <>
        Contact your admins to get a new invitation link.
        <br /> {name ? 'You can also take one of the following actions:' : 'You can also log in.'}
      </>
    }
    link="/"
    buttonText={
      name ? (
        <>
          Continue as <strong>{name}</strong>
        </>
      ) : (
        'Log in'
      )
    }
    backToLogin
  />
);
